import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const CreateRosterForm = () => {
  const { user } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    user_id: "",
    team_id: "",
    roster_type: "",
    clasification: "",
  });
  const location = useLocation(); // Obtiene la URL actual

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const teamId = searchParams.get("teamId");
    setFormData((prevFormData) => ({
      ...prevFormData,
      team_id: teamId,
      user_id: user.id,
    }));
  }, [location.search, user.id]); // Agrega user.id al arreglo de dependencias

  const handleCreateRoster = (rosterId) => {
    window.location.href = `/create-roster-player?rosterId=${rosterId}`;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://server-postgre.vercel.app/create-roster`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const newRoster = await response.json(); // Obtén el nuevo roster con su ID
      handleCreateRoster(newRoster.id); // Pasa la ID del roster a handleCreateRoster
    } catch (error) {
      console.error("Error al crear el roster:", error);
      // Manejo de errores...
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded shadow-md">
      <h2 className="text-lg font-semibold mb-6">Crear Roster</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="team_id"
          >
            Clasificación
          </label>
          <select
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="clasification"
            name="clasification"
            value={formData.clasification}
            onChange={handleChange}
            required
          >
            <option value="">Seleccionar clasificación</option>
            <option value="Sub20">Sub20</option>
            <option value="Sub18">Sub18</option>
          </select>
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="roster_type"
          >
            Tipo de Roster
          </label>
          <select
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="roster_type"
            name="roster_type"
            value={formData.roster_type} // Aquí está el problema
            onChange={handleChange}
            required
          >
            <option value="">Seleccionar tipo de roster</option>
            <option value="Principal">Principal</option>
            <option value="Reserva">Reserva</option>
          </select>
        </div>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="submit"
        >
          Crear Roster
        </button>
      </form>
    </div>
  );
};

export default CreateRosterForm;
